import { render, staticRenderFns } from "./DisplayCurrency.vue?vue&type=template&id=f17d547a"
import script from "./DisplayCurrency.vue?vue&type=script&lang=js"
export * from "./DisplayCurrency.vue?vue&type=script&lang=js"
import style0 from "./DisplayCurrency.vue?vue&type=style&index=0&id=f17d547a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports